import Image, { ImageProps } from 'components/gruenland/atoms/image';
import { useMemo } from 'react';

export interface PageImageProps {
  image: ImageProps;
  className?: string;
}

const PageImage: React.FC<PageImageProps> = ({ image, className }) => {
  const cropFocus = useMemo(() => {
    if (image.gravity?.coordinates) {
      const right = Math.ceil((image.gravity?.coordinates.x / (image.media?.width as number)) * 100);
      const top = Math.ceil((image.gravity?.coordinates.y / (image.media?.height as number)) * 100);
      return `right ${right.toString()}% top ${top.toString()}%`;
    }

    if (image.gravity?.mode === 'center') {
      return 'center';
    }

    return 'initial';
  }, [image]);

  return (
    image && (
      <Image
        priority
        loading="eager"
        style={{ objectFit: 'cover', objectPosition: cropFocus }}
        width={image.width}
        height={image.height}
        className={className}
        {...image}
      />
    )
  );
};

export default PageImage;
